import { Insurer } from "pmt-types/src/models/Insurer.ts";
import { useMutationSearchEntities } from "./useMutationSearchEntities.ts";

export const useMutationSearchInsurers = () =>
  useMutationSearchEntities<Insurer>("insurers");
